import { FeedPage } from './../feed/feed.component';
import { CreateClubSponsorshipPage } from '../create-club-sponsorship/create-club-sponsorship';
import { CreateClubStandalonePage } from '../create-club-standalone/create-club-standalone';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, PopoverController, Slide, Slides } from 'ionic-angular';

import { ProfilePage } from '../profile/profile';
import { SearchPage } from '../search/search';
import { ClubProvider } from '../../../providers/club/club';
import { AuthProvider } from '../../../providers/auth/auth';
import { FeedClub } from '../feed-club/feed-club.component';
import { ClubPopoverComponent } from '../../../components/club-popover/club-popover';
import { ClubMembersListPage } from './club-member-list/club-member-list';
import {AllClubs} from "./all-clubs/all-clubs";
import {TranslateService} from "@ngx-translate/core";
import {ClubDetails} from "./club-details/club-details";



@Component({
  selector: 'page-network',
  templateUrl: 'network.html',
})
export class NetworkPage {

  searchQuery = '';
  @ViewChild('clubSlide')  slides: Slides;
  @ViewChild('joinClubs')  slidesClub: Slides;
  constructor(public popoverCtrl: PopoverController,
              public navCtrl: NavController,
              public navParams: NavParams,
              public modalCtrl: ModalController,
              public clubProvider: ClubProvider,
              public toastCtrl: ToastController,
              public authProvider: AuthProvider,
              private translate: TranslateService) {
  }

  clubList: any;
  currUserId:string = '';
  // DOM utils :
  currUserMemberOf:any = [];
  currUserOwnerOf:any = [];

  myClubs = [];
  suggestedClubs = [];

  ngOnInit(){
    this.currUserId = this.authProvider.user.user_id;
  }

  ionViewDidLoad() {
    this.fetchClubs();
  }

  ionViewWillEnter(){
    this.fetchClubs();
   }

  fetchClubs(){
    this.clubProvider.getAll().subscribe((res) => {
      if(res.success){
        // Reset conditional dom array
        this.currUserMemberOf = [];
        this.myClubs = [];
        this.suggestedClubs = [];
        // Fetch
        this.clubList = res.data;
        this.clubList.forEach(club => {
          if(club.user_id == this.currUserId){
            this.currUserOwnerOf.push(club.id) // Store club IDs of which the user is owner of
          }
          club.Members.forEach(members => {
            if(members.user_id == this.currUserId){
              this.myClubs.push(club);
              this.currUserMemberOf.push(club.id) // Store clubs of which the user is member of
            }
          });
          if (!this.currUserMemberOf.includes(club.id)){
            this.suggestedClubs.push(club);
          }
        });
      }
    })
  }

  joinClub(id, name){
    this.clubProvider.join(id).subscribe((res) => {
      if(res.success){
        let toast = this.toastCtrl.create({
          message: 'Vous avez rejoint le club '+name,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.fetchClubs();
      }else{
        console.log(res)
      }
    })
  }

  // Settings
  presentPopover(event, clubId) {
    let isUserOwner = false;
    this.currUserOwnerOf.includes(clubId) ? isUserOwner = true : isUserOwner = false;

    let popover = this.popoverCtrl.create(ClubPopoverComponent, {clubId: clubId, userId: this.currUserId, isUserOwner: isUserOwner}, {
      cssClass: 'my-popover'
    });
    popover.onDidDismiss(() => {
      this.fetchClubs()
    });
    popover.present({
      ev: event
    });
  }

  // Slider functions
  public slideGoLeft(){
    this.slides.slideNext()
  }
  public slideGoRight(){
    this.slides.slidePrev();
  }
  public slideJoinLeft(){
    this.slidesClub.slideNext()
  }
  public slideJoinRight(){
    this.slidesClub.slidePrev();
  }

  // Routing

  createStandalone() {
    let modal = this.modalCtrl.create(CreateClubStandalonePage);
    modal.present().then(() => {});
    modal.onDidDismiss(() => this.fetchClubs())
  }

  seeFeedClub(club) {
    let modal = this.modalCtrl.create(FeedClub, {club: club});
    modal.present().then(() => {});
  }

  createSponsorship() {
    let modal = this.modalCtrl.create(CreateClubSponsorshipPage);
    modal.present().then(() => {});
    modal.onDidDismiss(() => this.fetchClubs())
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {}).present().then(() => {});
  }

  goToSearch() {
    this.navCtrl.push(SearchPage, {})
      .then(() => {
        console.log('Welcome to search');
      })
  }

  showMembers(clubId){
    let modal = this.modalCtrl.create(ClubMembersListPage, {clubId: clubId})
    modal.present().then(() => {});
  }

  goToAllClubs(myClubs: boolean) {
      const titleKey = myClubs ? 'network.myclubs' : 'network.joinclub';
      const clubs = myClubs ? this.myClubs : this.suggestedClubs
      let modal = this.modalCtrl.create(AllClubs, {clubs: clubs,
                                            myClubs: myClubs,
                                            title: this.translate.instant(titleKey),
                                            currUserOwnerOf: this.currUserOwnerOf,
                                            currUserId: this.currUserId});
      modal.onDidDismiss(() => this.fetchClubs());
      modal.present();
  }

  viewClub(club) {
    let modal = this.modalCtrl.create(ClubDetails, { club: club });
    modal.onDidDismiss(() => this.fetchClubs());
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/network/network.ts